/* src/app/shared/phar-dropdown-timepicker2/phar-dropdown-timepicker2.component.scss */
:host {
  display: block;
  width: 100%;
}
:host.ng-invalid.ng-touched ::ng-deep input {
  border: 1px solid var(--c-red2) !important;
}
:host.ng-invalid.ng-touched ::ng-deep .p-datepicker:not(.p-disabled):not(.p-focus) input {
  border-color: var(--c-red2) !important;
}
/*# sourceMappingURL=phar-dropdown-timepicker2.component.css.map */
